import { TrainingRoutingModule } from './training.routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedAppModule } from '../app.module.shared';
import { TrainingCalendarComponent } from './training.calendar/training.calendar.component';
import { TrainingClassComponent } from './training.class/training.class.component';
import { TrainingAttendanceComponent } from './training.attendance/training.attendance.component';

@NgModule({
  imports: [
    CommonModule,
    SharedAppModule,
    TrainingRoutingModule
  ],
  declarations: [
    TrainingCalendarComponent,
    TrainingClassComponent,
    TrainingAttendanceComponent
  ]
})
export class TrainingModule { }
